module.exports = __webpack_public_path__ + "static/fonts/Outage-Cut.2638b4b.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/formats/font/Outage-Cut.ttf
// module id = bqun
// module chunks = 1